export default __webpack_public_path__ + "static/media/Place_card.c851eca4.gif";